import { render } from "./AddStaff.vue?vue&type=template&id=19f2a5a6&scoped=true"
import script from "./AddStaff.vue?vue&type=script&lang=js"
export * from "./AddStaff.vue?vue&type=script&lang=js"

import "./AddStaff.vue?vue&type=style&index=0&id=19f2a5a6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19f2a5a6"]])

export default __exports__